
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import {
  AUTHENTICATION_ERROR,
  CONNECTION_ERROR,
  TIMEOUT_ERROR
} from '@segment/db-connect/constants'
import Space from 'ui/Space'
import Button from 'ui/Button'
import ConnectingLoader from 'ui/ConnectingLoader'
import SetupError from '../setup-error'

class WarehouseSetupError extends Component {
  render () {
    return (
      <div>
        <ConnectingLoader logo={this.props.logo} name={this.props.name} />
        <Space value='50' />
        {this.renderError(this.props.error, this.props.shouldShowContactUs)}
      </div>
    )
  }

  renderError (error, shouldShowContactUs) {
    const contactUsButton = shouldShowContactUs
      ? <Button modifier='secondary' href='/contact/support/warehouses' rel='external'>Contact Support</Button>
      : null

    switch (error.code) {
      case TIMEOUT_ERROR:
      case 504: // if the ELB times us out, we won't be able to properly set the `.code` constant
        return (
          <SetupError title='Connection timeout' message='We weren’t able to connect to your database for more than 30 seconds. Double-check that your credentials are correct and try again.'>
            {contactUsButton}
            <Button onClick={this.props.onEditCredentials}>Edit Credentials</Button>
          </SetupError>
        )
      case AUTHENTICATION_ERROR:
        return (
          <SetupError title='Invalid credentials' message='You may have copied the details incorrectly. Double-check to make sure all of the fields are correct and then try again.'>
            {contactUsButton}
            <Button onClick={this.props.onEditCredentials}>Edit Credentials</Button>
          </SetupError>
        )
      case CONNECTION_ERROR:
        return (
          <SetupError title='Network error' message='We weren’t able to connect to your database because of a networking error. This typically happens when your database doesn’t close the connection properly or gets rebooted. If you see this error multiple times please contact us.'>
            {contactUsButton}
            <Button onClick={this.props.onRetry}>Try again</Button>
          </SetupError>
        )
      case 'ENOTFOUND':
        return (
          <SetupError title='Invalid hostname' message='We weren’t able to connect to that hostname. Check that it’s correct and try again.'>
            {contactUsButton}
            <Button onClick={this.props.onEditCredentials}>Edit Credentials</Button>
          </SetupError>
        )
      default:
        return (
          <SetupError title='An unexpected error occurred' message={error.error || 'Please try again'}>
            {contactUsButton}
            <Button onClick={this.props.onRetry}>Try again</Button>
          </SetupError>
        )
    }
  }
}

WarehouseSetupError.displayName = 'WarehouseSetupError'

WarehouseSetupError.propTypes = {
  error: PropTypes.object.isRequired,
  logo: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  onEditCredentials: PropTypes.func.isRequired,
  onRetry: PropTypes.func.isRequired,
  shouldShowContactUs: PropTypes.bool.isRequired
}

export default WarehouseSetupError



// WEBPACK FOOTER //
// ./pages/workspace-warehouses/components/warehouse-setup-error/index.js